export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/vector.6cfe0b13.svg","height":436,"width":414,"blurWidth":0,"blurHeight":0};